import { memo, useEffect, useState } from "react";
import styles from "./Layout.module.scss";
import momentTz from "moment-timezone";
import { useIntl } from "react-intl";

function MoscowTime() {
  const { formatMessage } = useIntl();
  const [utcTime, setUtcTime] = useState<number>(0);

  useEffect(() => {
    const checkTime = setInterval(() => {
      const delta = window.SERVER_TIME_DELTA ? window.SERVER_TIME_DELTA : 0;
      // console.log("use delta: " + window.SERVER_TIME_DELTA);
      setUtcTime(new Date().getTime() + delta);
    }, 1000);
    return () => clearInterval(checkTime);
  }, [utcTime]);

  return utcTime !== 0 ? (
    <div className={styles.moscow_time}>
      <p>
        {/* <b>{momentTz.tz(utcTime, "Europe/Moscow").format("HH:mm:ss")}</b>{" "}
        <span className="no-wrap">
          ({formatMessage({ id: "header.time" })})
        </span>{" "} */}
        <span>
          {" "}
          <b>{momentTz.tz(utcTime, "UTC").format("HH:mm:ss")}</b> (UTC)
        </span>
      </p>
    </div>
  ) : null;
}

export default memo(MoscowTime);
